import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { LeftOutlined } from "@ant-design/icons";
import profile from "../assets/profile.png";
import send from "../assets/orders/send.png";
import { Drawer, Rate } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { fetchOrderById } from "../redux/ShowOrderIdSlice";
import { createAgentChat } from "../redux/createChatAgentSlice";
import { sendMessage } from "../redux/sendMSSlice";
import dayjs from "dayjs";
import verify from "../assets/productView/verify.png";
import { fetchAgentRate } from "../redux/getAgentRateIdSlice";

const ChatApp = () => {
    const { idOrder } = useParams();
    const dispatch = useDispatch();

    const { order } = useSelector((state) => state.order);
    const { chatid, status: chatStatus } = useSelector((state) => state.createChatAgent);
    const { status: sendStatus } = useSelector((state) => state.sendMS);
    const { AgentRate } = useSelector((state) => state.AgentRate);

    const [messages, setMessages] = useState([]);
    const [newMessage, setNewMessage] = useState("");

    // Fetch order details
    useEffect(() => {
        dispatch(fetchOrderById(idOrder));
    }, [dispatch, idOrder]);

    useEffect(() => {
        dispatch(fetchAgentRate(order?.agent_id));
    }, [dispatch, order?.agent_id]);

    console.log(AgentRate);

    // Create chat if needed
    useEffect(() => {
        if (chatStatus === "idle" && order?.agent?.id) {
            dispatch(
                createAgentChat({
                    order_id: idOrder,
                    agent_id: order.agent.id,
                })
            );
        }
    }, [dispatch, chatStatus, idOrder, order]);

    // Load messages from chatid
    useEffect(() => {
        if (chatid?.messages) {
            const formattedMessages = chatid.messages.map((msg) => ({
                id: msg.id,
                text: msg.message,
                sender: msg.role,
                time: dayjs(msg.created_at).format("hh:mm A"),
                date: dayjs(msg.created_at).format("MMMM DD, YYYY"),
                createdAt: msg.created_at,
            }));

            const sortedMessages = formattedMessages.sort((a, b) =>
                dayjs(a.createdAt).isAfter(dayjs(b.createdAt)) ? 1 : -1
            );

            setMessages(sortedMessages);
        }
    }, [chatid]);

    // Handle sending messages
    const handleSendMessage = () => {
        if (newMessage.trim()) {
            const messageData = {
                chat_id: chatid.id,
                message: newMessage,
            };

            // Dispatch sendMessage action
            dispatch(sendMessage(messageData))
                .then(() => {
                    const now = dayjs(); // Current time
                    setMessages((prev) => [
                        ...prev,
                        {
                            id: prev.length + 1,
                            text: newMessage,
                            sender: "user",
                            time: now.format("hh:mm A"),
                            date: now.format("MMMM DD, YYYY"),
                            createdAt: now.toISOString(),
                        },
                    ]);

                    setNewMessage("");
                })
                .catch((err) => {
                    console.error("Failed to send message:", err);
                });
        }
    };

    const [open, setOpen] = useState(false);
    const showDrawer = () => setOpen(true);
    const onClose = () => setOpen(false);

    return (
        <div className="chat-container">
            <div className="bg-[#FCFBFA] px-20 max-lg:px-5 py-8 sticky top-0">
                <Link to="/myorders" className="flex items-center text-[#283D63] font-semibold">
                    <LeftOutlined />
                    <p className="ml-3">Back to my orders</p>
                </Link>
                <div className="flex items-center justify-between mt-8">
                    <div className="flex items-center">
                        {order?.agent?.image ? (
                            <img
                                src={`https://service.samoolah.com${order.agent.image}`}
                                className="w-[58px] max-lg:w-[45px] mr-5 rounded-full"
                                onError={(e) => (e.target.src = profile)}
                            />
                        ) : (
                            <img src={profile} className="w-[58px] max-lg:w-[45px] mr-5" />
                        )}
                        <p className="text-[#14294F] font-semibold text-2xl max-lg:text-xl">
                            {order?.agent?.name} {order?.agent?.last_name}
                        </p>
                    </div>
                    <button onClick={showDrawer} className="flex items-center">
                        <div className="bg-[#FE6625] rounded-full p-1"></div>
                        <div className="bg-[#FE6625] rounded-full p-1 ml-1"></div>
                        <div className="bg-[#FE6625] rounded-full p-1 ml-1"></div>
                    </button>

                    <Drawer size='large' title={<span className="bg-[#C8E9C0] w-[100px] rounded-xl px-4 py-2 text-white flex justify-end ml-auto">{order?.agent?.is_available == "1" ? "Available" : "Not available"}</span>} onClose={onClose} open={open}>
                        <div className="mx-auto">
                            <div className="text-center">
                                {order?.agent?.image ? (
                                    <img
                                        src={`https://service.samoolah.com${order.agent.image}`}
                                        className="w-[88px] max-lg:w-[58px] mx-auto rounded-full"
                                        onError={(e) => (e.target.src = profile)}
                                    />
                                ) : (
                                    <img src={profile} className="w-[58px] max-lg:w-[58px] mx-auto" />
                                )}
                                <p className="text-[#14294F] font-semibold text-2xl max-lg:text-xl my-5 text-center">
                                    {order?.agent?.name} {order?.agent?.last_name}
                                </p>
                                <Rate disabled defaultValue={order?.agent?.rate} />
                            </div>
                            <div className="text-center">
                                <p className="text-lg text-[#283D63] mt-3 font-semibold">Specialties:</p>
                                <div >
                                    <div className={`relative`}>
                                        <div className="bg-white rounded-full w-[90px] h-[90px] max-lg:w-[60px] max-lg:h-[60px] flex items-center mx-auto my-5 lg:p-4 max-lg:p-2" style={{ boxShadow: "0px 2px 10px 6px #c3c3c326" }}>
                                            <img src={`https://service.samoolah.com/${order?.category?.icon}`} className="mx-auto max-lg:w-[40px]" width="60px" />
                                        </div>
                                    </div>
                                    <p className="text-[#63718A] text-lg">{order?.category?.name_en}</p>
                                </div>
                            </div>
                            <div>
                                <p className="text-lg text-[#283D63] mt-3 font-semibold">Reviews:</p>
                                <div>
                                    {
                                        AgentRate.length > 0 ?
                                            AgentRate?.map((rate, index) => (
                                                <div className="mb-4" key={index}>
                                                    <div className="flex items-center justify-between">
                                                        <div className="flex items-center my-4 max-lg:mr-2">
                                                            <div>
                                                                <img
                                                                    src={rate.user?.image == null ? profile : `https://samoolah.com${rate.user?.image}`}
                                                                    className="w-[50px] max-lg:w-[30px] rounded-full"
                                                                />
                                                            </div>
                                                            <div className="ml-3 font-semibold">
                                                                <p className="text-[#14294F] text-lg mb-1">{rate.user?.name}</p>
                                                                <Rate disabled defaultValue={rate.rate} className="" />
                                                            </div>
                                                        </div>

                                                        <div className="flex items-center">
                                                            <img src={verify} className="w-[30px] max-lg:w-[20px]" />
                                                            <p className="text-[#6575CC] ml-2 lg:text-lg">
                                                                Verified Purchase
                                                            </p>
                                                        </div>
                                                    </div>
                                                    {/* <p className="text-[#737E91]">Reviewed on 9 April 2024</p> */}
                                                    <p className="text-[#737E91] lg:text-lg mt-3">
                                                        {rate.rate_comment}
                                                    </p>
                                                </div>
                                            ))
                                            :
                                            <p className="text-[#63718A] text-lg">No reviews added yet</p>

                                    }

                                </div>
                            </div>
                        </div>
                    </Drawer>
                </div>
            </div>

            {/* Chat Messages */}
            <div className="chat-box px-20 max-lg:px-5 py-5 pb-20">
                {(() => {
                    let previousDate = null;
                    return messages.map((message) => {
                        const showDate = message.date !== previousDate;
                        previousDate = message.date;

                        return (
                            <div key={message.id}>
                                {showDate && (
                                    <div className="text-center text-[#283D63] font-medium text-xl mb-10">
                                        {message.date}
                                    </div>
                                )}
                                <div className="mb-3">
                                    <div
                                        className={`chat-message w-2/5 max-lg:w-full text-lg px-8 py-4 ${message.sender === "user"
                                            ? "user-message bg-[#EF9D7A] text-[#FCFBFA] rounded-l-3xl rounded-tr-3xl rounded-br-lg ml-auto"
                                            : "agent-message bg-[#FCFBFA] text-[#717D91] border-2 border-[#FFD3C4] rounded-r-3xl rounded-tl-3xl rounded-bl-lg"
                                            }`}
                                    >
                                        <p>{message.text}</p>
                                    </div>
                                    <p
                                        className={`text-[#EF9D7A] ${message.sender === "user" ? "text-end mt-1" : ""
                                            }`}
                                    >
                                        {message.time}
                                    </p>
                                </div>
                            </div>
                        );
                    });
                })()}
            </div>


            <div className="bg-white input-box fixed bottom-0 w-full border-t-2 border-[#EAA182]">
                <div className="flex items-center justify-between px-20 max-lg:px-5 py-5">
                    <input
                        type="text"
                        value={newMessage}
                        onChange={(e) => setNewMessage(e.target.value)}
                        placeholder="Type text here..."
                        className="border-0 w-full mr-5"
                    />
                    <button onClick={handleSendMessage}>
                        <img src={send} className="w-[38px]" />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ChatApp;